import * as types from "./mutation-types";
import defaultState from "./defaultState";

const organizationsMutations = {
  [types.SET_ORGANIZATIONS](state, organizations) {
    state.organizations = organizations;
  },

  [types.ADD_ORGANIZATION](state, organization) {
    state.organizations.push(organization);
  },

  [types.UPDATE_EDITED_ORGANIZATION_VALUE](state, data) {
    state.editedOrganization[data.key] = data.value;
  },

  [types.SET_EDITED_ORGANIZATION](state, organization) {
    state.editedOrganization = organization;
  },

  [types.SET_MEMBER_ORGANIZATION](state, organization) {
    state.memberOrganization = organization;
  },

  [types.SET_ORGANIZATION_MEMBERS_RESPONSE_OBJECT](state, data) {
    state.organizationMembersResponseObject = data;
  },

  [types.SET_MOBILE_ORGANIZATION](state, organization) {
    state.mobileOrganization = organization;
  },

  [types.SET_CHALLENGES](state, challenges) {
    state.organizationChallenges = challenges;
  },

  [types.SET_TEAMS_ORGANIZATION](state, teams) {
    state.organizationTeams = teams;
  },

  [types.RESET_ORGANIZATIONS_STATE](state) {
    Object.keys(defaultState()).forEach(key => {
      state[key] = defaultState()[key];
    });
  }
};

const mutations = {
  [types.SET_LOADED_STATUS](state, data) {
    state[data.key] = data.value;
  }
};

Object.assign(mutations, organizationsMutations);

export default mutations;
